import React from 'react';
import PropTypes from 'prop-types';
import { Notification } from '@telus-uds/components-web';

const NotificationBanner = ({ notification, onClose }) => {
  if (!notification) return null;

  const variantMap = {
    success: { style: 'success' },
    error: { validation: 'error' }
  };

  return (
    <Notification
      variant={variantMap[notification.type] || { style: 'success' }}
      dismissible={notification.type === 'success'}
      onDismiss={onClose}
    >
      {notification.message}
    </Notification>
  );
};

NotificationBanner.propTypes = {
  notification: PropTypes.shape({
    message: PropTypes.string,
    type: PropTypes.string
  }),
  onClose: PropTypes.func.isRequired
};

export default NotificationBanner;
